import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask3500To3599Service {

  constructor() { }
}
